//
import ExtendModel from '@/models/ExtendModel'

/**
 * @class
 * @extends ExtendModel
 */
export default class PchSelectedProviderPurchaseQuotation extends ExtendModel {
    /**
     * @description
     *
     */
    get has_branch_offices() {
        return this.branch_offices.length > 0
    }

    /**
     * @description
     *
     */
    get pch_provider_branch_offices_address() {
        return this.has_branch_offices
            ? this.branch_offices_selected.address
            : ''
    }

    /**
     * @description
     *
     */
    get branch_offices_pop() {
        return this.branch_offices.slice().pop()
    }

    /**
     * @description
     *
     */
    get branch_offices_selected() {
        return this.branch_offices.find(
            ({ g_branch_office_id }) =>
                this.branch_offices_id === g_branch_office_id
        )
    }

    /**
     * @description
     *
     */
    reset() {
        //
        this.pch_provider_branch_offices_id = this.has_branch_offices
            ? this.branch_offices_pop.id
            : ''

        //
        return this
    }
}
